// extracted by mini-css-extract-plugin
export default {"no-weather-icon":"style_no-weather-icon__ikl40"};